import { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import {
	CulturaIcon,
	DesempenoIcon,
	EntrenamientoIcon,
	FormacionIcon,
	HabilidadesIcon,
	HistoricoProfessionalIcon,
	MotivacionesIcon,
	PlanCarreraIcon,
	PropositoIcon,
	SalarioIcon,
} from '../../../../Icons/CollaboratorsIcons'
import { lateralMenuTextTranslate, wheelCollaboratorTranslate } from '../../../../i18n/translatedMessages'

import { BsFileText } from 'react-icons/bs'
import './SideMenu.sass'
import { NominaIcon } from '../../../Services/Components/NewMenu/MenuIcons'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

const links = [
	{
		id: 1,
		name: wheelCollaboratorTranslate.professionalHistoric,
		icon: <HistoricoProfessionalIcon />,
		link: '/employee/professionalinfo',
	},
	{
		id: 13,
		name: wheelCollaboratorTranslate.documentsTitle,
		icon: <BsFileText size={20} />,
		link: '/employee/documents',
		submenus: [
			{
				id: 14,
				name: wheelCollaboratorTranslate.admissionDocuments,
				icon: <BsFileText />,
				link: '/employee/documents',
			},
			{
				id: 15,
				name: 'Nómina',
				icon: <BsFileText />,
				link: '/employee/nomina',
			},
			{
				id: 16,
				name: 'Gestión de Documentos',
				icon: <BsFileText />,
				link: '/employee/document-manager',
			},
			{
				id: 17,
				name: 'Gestión de Conocimientos',
				icon: <BsFileText />,
				link: '/employee/knowledge-management',
			},
			{
				id: 18,
				name: 'Ranking Conocimientos',
				icon: <BsFileText />,
				link: '/employee/knowledge-ranking',
			},
		],
	},
	{
		id: 2,
		name: wheelCollaboratorTranslate.purpose,
		icon: <PropositoIcon />,
		link: '/employee/proposito',
	},
	{
		id: 3,
		name: wheelCollaboratorTranslate.formation,
		icon: <FormacionIcon />,
		link: '/employee/formationinfo',
	},
	{
		id: 4,
		name: wheelCollaboratorTranslate.climeAndCulture,
		icon: <CulturaIcon />,
		link: '/employee/climaycultura',
	},
	{
		id: 5,
		name: wheelCollaboratorTranslate.salary,
		icon: <SalarioIcon />,
		link: '/employee/salaryinfo',
	},
	{
		id: 6,
		name: wheelCollaboratorTranslate.habilities,
		icon: <HabilidadesIcon />,
		link: '/employee/assessment',
	},
	{
		id: 7,
		name: wheelCollaboratorTranslate.motivacions,
		icon: <MotivacionesIcon />,
		link: '/employee/motivaciones',
	},
	// {
	// 	id: 8,
	// 	name: wheelCollaboratorTranslate.performance,
	// 	icon: <DesempenoIcon />,
	// 	link: '/employee/desempeno',
	// },
	{
		id: 8,
		name: 'Desempeño y Potencial',
		icon: <DesempenoIcon />,
		link: '/employee/performance-y-potential',
	},
	{
		id: 9,
		name: wheelCollaboratorTranslate.evalutation360,
		icon: <DesempenoIcon />,
		link: '/employee/evaluation',
		submenus: [
			{
				id: 91,
				name: wheelCollaboratorTranslate.addEvalutation360,
				link: '/employee/evaluation',
			},
			{
				id: 92,
				name: wheelCollaboratorTranslate.historicalEvalutation360,
				link: '/employee/evaluation/historical',
			},
		],
	},
	{
		id: 10,
		name: 'Feedbacks', //wheelCollaboratorTranslate.evalutation360,
		icon: <img src='https://assets.mydna.company/evaluacion_white.svg' alt='' className='tw-h-8 tw-w-8 tw-mx-3' />,
		link: '/employee/feedbacks',
		submenus: [
			{
				id: 12,
				name: 'Recebidos',
				link: '/employee/feedbacks',
			},
			{
				id: 11,
				name: 'Enviados',
				link: '/employee/feedbacks/sent',
			},
		],
	},
	{
		id: 11,
		name: wheelCollaboratorTranslate.careerPlan,
		icon: <PlanCarreraIcon />,
		link: '/employee/career-plan',
	},
	{
		id: 12,
		name: wheelCollaboratorTranslate.training,
		icon: <DesempenoIcon />,
		link: '/employee/entrenamiento',
	},
]

/* 
	id: 10,
	name: wheelCollaboratorTranslate.training,
	icon: <EntrenamientoIcon />,
	link: '/employee/entrenamiento',
	submenus: [
		{
			id: 81,
			name: 'Mis Entrenamientos',
			link: '/employee/entrenamiento',
		},
		{
			id: 82,
			name: lateralMenuTextTranslate.manageCompetences,
			link: '/employee/development-guide',
		},
	],
 */

const SideMenu = ({ handleMenu, option }) => {
	const pathname = useLocation().pathname
	const splitpath = pathname.split('/')
	const linkname = `/${splitpath[1]}/${splitpath[2]}`
	const [openMenu, setOpenMenu] = useState(null)

	const toggleMenu = id => {
		setOpenMenu(prev => (prev === id ? null : id))
	}

	return (
		<div className={pathname === '/employee' ? 'd-none' : 'sideMenu-main pe-4'}>
			<ul>
				{links.map((item, key) => {
					const hasSubmenu = !!item.submenus
					const isOpen = openMenu === item.id
					const isActive = linkname === item.link || (hasSubmenu && item.submenus.some(sub => sub.link === pathname))

					return (
						<div key={key}>
							{hasSubmenu ? (
								<>
									<li
										onClick={() => toggleMenu(item.id)}
										data-option={item.id}
										className={`tw-rounded-lg tw-cursor-pointer tw-flex tw-items-center tw-bg-black ${
											isActive ? 'active-menu-plan' : 'hover:tw-bg-[#5F52C4]'
										}`}
									>
										<div className='tw-flex tw-items-center'>
											{item.icon}
											<span>{item.name}</span>
										</div>
									</li>
									{isOpen && (
										<ul>
											{item.submenus.map(submenu => (
												<NavLink key={submenu.id} to={submenu.link}>
													<li
														className={`hover:tw-bg-[#05ACF2] ${
															pathname === submenu.link
																? 'tw-bg-[#05ACF2] tw-rounded-r-full tw-text-white'
																: 'tw-bg-gray-100 tw-rounded-lg tw-text-gray-700'
														} tw-pl-4`}
														style={{ color: 'rgb(51,65,85)', marginLeft: 0, paddingLeft: 0 }}
													>
														{submenu.icon && submenu.icon}
														<span className='tw-ml-2'>{submenu.name}</span>
													</li>
												</NavLink>
											))}
										</ul>
									)}
								</>
							) : (
								<NavLink to={item.link}>
									<li
										onClick={handleMenu}
										data-option={item.id}
										className={`tw-rounded-lg ${isActive ? 'active-menu-plan' : 'hover:tw-bg-[#5F52C4]'} tw-bg-black`}
									>
										{item.icon}
										<span>{item.name}</span>
									</li>
								</NavLink>
							)}
						</div>
					)
				})}
			</ul>
		</div>
	)
}

export default SideMenu
